export default "__VITE_ASSET__DFFsJIJR__"